// extracted by mini-css-extract-plugin
module.exports = {"layout":"dd31006766--layout--J3CSz","white":"dd31006766--white--A3MWr","black":"dd31006766--black--uxlyU"};